import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme from '../../styles/theme';
import { ribbonType } from '../../propTypes';
import Ribbon from './Ribbon';

const formatPrice = dollars => (
  `$${dollars.toLocaleString('en-AU', {
    minimumFractionDigits: dollars % 1 === 0 ? 0 : 2, // 1.3 => 1.30; 1.00 => 1
  })}`
);

const Price = ({
  classes, className, price, ribbon, specialPrice,
}) => {
  const isSpecial = !!specialPrice;
  return (
    <p className={cn(className, classes.price)}>
      <span className={cn(classes.priceText, isSpecial && classes.wasPrice)}>
        {price && formatPrice(price)}
      </span>
      {isSpecial && (
        <span className={classes.specialPrice}>
          {`\xa0${formatPrice(specialPrice)}`}
        </span>
      )}
      {ribbon && <Ribbon className={classes.ribbon} {...ribbon} />}
    </p>
  );
};

Price.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  ribbon: ribbonType,
  price: PropTypes.number,
  specialPrice: PropTypes.number,
};

Price.defaultProps = {
  className: undefined,
  price: undefined,
  ribbon: undefined,
  specialPrice: undefined,
};

export default injectSheet({
  price: {
    '&&': {
      fontSize: '14px',
      fontWeight: '600',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'baseline',
    },
  },
  wasPrice: {
    textDecoration: 'line-through',
    color: theme.colors.inactiveBtn,
  },
  priceText: {
    marginRight: 2,
    fontFamily: theme.fonts.body,
  },
  specialPrice: {
    extend: 'priceText',
    color: theme.colors.sale,
    marginLeft: 0,
  },
  ribbon: {
    flexBasis: '100%',
    marginTop: 2,
  },
})(Price);
